type Props = {
  readonly disabled: boolean;
  readonly label: string;
  readonly onClick: () => void;
  readonly tone?: "ink" | "muted";
};

export const ExecuteButton = ({ disabled, label, onClick, tone = "ink" }: Props) => {
  const enabled = !disabled;
  const palette =
    tone === "muted" || !enabled
      ? {
          background: "var(--line-1)",
          color: "var(--ink-3)",
          border: "1px solid var(--line-2)",
        }
      : {
          background: "var(--ink-1)",
          color: "var(--on-light)",
          border: "1px solid var(--ink-1)",
        };

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className="w-full h-14 rounded-[var(--radius-sm)] text-[12px] tracking-[0.24em] uppercase transition-all"
      style={{ ...palette, fontWeight: 500 }}
    >
      {label}
    </button>
  );
};
